<template>
  <div class="text-container" :style="{
    'margin-top': cc.margin_top + 'px',
    'margin-bottom': cc.margin_bot + 'px'
  }">

    <h2 class="text-title" v-if="cc.title" :style="{'color': gc.text_color, 'color': cc.color || gc.main_color,}">{{cc.title}}</h2>
    <div class="text-list" ref="text-list">
        <p v-for="item in cc.text_list" :key="item" class="text" :style="{
        'color': cc.color || gc.main_color,
        'opacity': cc.opacity,
        'font-size': cc.font_size + 'px',
        'line-height': cc.line_height + 'px',
        'text-align': cc.align || 'left'
      }" v-html="item">
        
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cc: { // component_conf
      type: Object,
      default: () => {}
    },
    gc: { // common_config
      type: Object,
      default: () => {}
    }
  },
}
</script>

<style lang="less" scoped>
.text-container {
  margin: 32px 14px 0;
  .text-title {
    font-size: 20px;
    line-height: 26px;
  }
  .text-list {
    margin-top: 4px;
    .text {
      font-size: 13px;
      line-height: 22px;
      opacity: .8;
    }
  }
  
}
</style>